export default {
  sections: {
    my_area: "My Area",
    administration: "Administration",
  },

  items: {
    my_dashboard: "My Dashboard",
    my_statement: "My Statement",
    my_contributions: "My Contributions",
    my_loans: "My Loans",
    my_loans_list: "My Loans",
    loan_applications: "Loan Applications",
    my_penalties: "My Penalties",
    my_withdrawals: "My Withdrawals",

    admin_overview: "Admin Overview",
    members: "Members",
    finance: "Finance",
    statement: "Statement",
    contributions: "Contributions",
    expenses: "Expenses",
    penalties: "Penalties",
    withdrawals: "Withdrawals",
    reconciliation: "Reconciliation",
    matrix_report: "Matrix Report",

    loans: "Loans",
    all_loans: "All Loans",
    repayment_sheet: "Repayment Sheet",
    bulk_loan_migration: "Bulk Loan Migration",
    loan_applications_review: "Loan Applications Review",

    investments: "Investments",
    commitments: "Commitments",
    settings: "Settings",
    financial_years: "Financial Years",
    fy_closure: "Financial Year Closure",
    group_rules: "Group Rules",
  },
};
